import { UserLocale } from '@teetsh/app/src/types/user';
import {
  Planner,
  PlannerCategoriesPDFSettings,
} from '@teetsh/app/src/types/planner';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  planner: Planner;
  lng: UserLocale;
  chronologicalOrder: boolean;
  settings: PlannerCategoriesPDFSettings;
  selectedCategories?: string[];
}

export function buildPlannerCategoriesPDFParams({
  planner,
  lng,
  chronologicalOrder,
  settings,
  selectedCategories,
}: Props) {
  const params = new URLSearchParams({
    lng,
    chronologicalOrder: chronologicalOrder ? 'true' : 'false',
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
  });

  if (selectedCategories && selectedCategories.length > 0) {
    params.set('selectedCategories', selectedCategories.join(','));
  }

  if (!_isEmpty(planner.title)) {
    params.set('title', planner.title);
  }

  if (!_isEmpty(planner.subtitle)) {
    params.set('subtitle', planner.subtitle!);
  }

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
